import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const yandexMusic: MusicService = {
  id: 'yandex-music',
  appId: 'yandex',
  name: 'Yandex Music',
  shortName: 'Yandex Music',
  isSupported: false,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#ff3333',
    label: '#FF5555',
    background: '#8b7372',
  },
  importerID: ImporterID.Yandex,
  musicAPIID: MusicAPIIntegrationID.YandexMusic,
  linkType: 'yandexmusic',
  assets: {
    logo: { light: 'yandex-light.svg', dark: 'yandex-dark.svg' },
    logoPadding: { light: 'yandex-light-padding.svg', dark: 'yandex-dark-padding.svg' },
    logoColor: { light: 'yandex-color-light.svg', dark: 'yandex-color-dark.svg' },
    logoColorPadding: {
      light: 'yandex-color-light-padding.svg',
      dark: 'yandex-color-dark-padding.svg',
    },
    logoOnBackground: 'yandex-color-dark.svg',
  },
  whatIsDescription: musicServiceMessages.yandexMusicWhatIs,
};
